module.exports = __webpack_public_path__ + "static/media/cluster_fmt_new.0a763cc0.svg";